const status_dialog = {
	description: "Change the status of your machine here.",
	status: {
		created_snapshot: "Snapshot added to VPS <strong>{{name}}</strong>.",
		deleted_snapshot: "Snapshot <strong>{{name}}</strong> has been successfully deleted.",
		forced_reset: "Resetting VPS <strong>{{name}}</strong>.",
		forced_shutdown: "Shutting down VPS <strong>{{name}}</strong>, this may take a few seconds.",
		reboot: "We have requested the OS of VPS <strong>{{name}}</strong> to reboot.",
		rollback: "Your VPS has been restored using snapshot <strong>{{name}}</strong>.",
		shutdown:
			"We have requested the OS of VPS <strong>{{name}}</strong> to shut down. Please be aware that this may take a moment.",
		start: "Starting VPS <strong>{{name}}</strong>, this may take a few seconds.",
		updated_snapshot: "Snapshot <strong>{{name}}</strong> has been successfully updated.",
	},
	title: "Change VPS Status",
};

export default status_dialog;
